import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { get } from 'lodash';
import { showNotification } from 'libs/utils';

function NotificationMessage() {
  const location = useLocation();

  useEffect(() => {
    const notification = get(location, 'state.notification');
    if (notification && notification.type && notification.message) {
      showNotification(notification.type, notification.message);
    }
  }, [location]);

  return <></>;
}

NotificationMessage.defaultProps = {};

export default NotificationMessage;
